var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramMobile48(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pictogram/Small./Mobile48",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bounding-Box",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }), /*#__PURE__*/React.createElement("g", {
    id: "pictogram",
    transform: "translate(10.800000, 2.000000)",
    stroke: "#4F4C4D",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    id: "device",
    fill: "#FFFFFF",
    x: 0.95,
    y: 0.75,
    width: 24.5,
    height: 41.5,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.95,35.75 L0.95,40.0000567 C0.95,41.7891999 2.41061266,43.25 4.20552025,43.25 L22.1944797,43.25 C23.9965965,43.25 25.45,41.7970548 25.45,40.0000567 L25.45,35.75 L0.95,35.75 Z",
    id: "Focus",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "home-button",
    fill: "#FFFFFF",
    cx: 12.95,
    cy: 39.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.95,39.3 L20.45,39.3",
    id: "action-button",
    strokeLinecap: "square"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramMobile48);
export default __webpack_public_path__ + "static/media/pictogramMobile48.dd1b32ac9131bdd49c0e9a9e00596e38.svg";
export { ForwardRef as ReactComponent };